// extracted by mini-css-extract-plugin
export default {"root":"primecost_root__cFg-C","top":"primecost_top__W1+4V","table":"primecost_table__l-vtG","details":"primecost_details__mq6aB","detailschild":"primecost_detailschild__bL8Wg"};